import React from 'react'

const EditIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="editGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 180, 100, 1)" />
          <stop offset="100%" stopColor="rgba(230, 140, 60, 1)" />
        </linearGradient>
        <filter id="editGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Pencil body */}
      <path 
        d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
        fill="url(#editGradient)"
        filter="url(#editGlow)"
      />
      
      {/* Pencil tip line */}
      <line 
        x1="15" 
        y1="9" 
        x2="9" 
        y2="15" 
        stroke="rgba(255, 255, 255, 0.5)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default EditIcon
